/*
 * Public API Surface of ng-shimmer
 */
export * from './lib/shimmer.component';
export * from './lib/shimmer.model';
export * from './lib/shimmer.module';
export * from './lib/shimmer.token';
